import { PricedItem } from '@shared/types/priced-item';
import { Button } from '@web/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@web/components/ui/dropdown-menu';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@web/components/ui/table';
import { Plus, Trash2 } from 'lucide-react';

import { ScrollArea } from '@web/components/ui/scroll-area';

export default function PriceTable({
  items,
  setItems,
  allItems,
  itemType,
}: {
  items: PricedItem[];
  setItems: (items: PricedItem[]) => void;
  allItems: PricedItem[];
  itemType: string;
}) {
  const addItem = (itemId: string) => {
    const newItem = allItems.find((p) => p.id === itemId);

    if (newItem && !items.some((p) => p.id === newItem.id)) {
      setItems([...items, newItem]);
    }
  };

  const removeItem = (id: string) => {
    setItems(items.filter((p) => p.id !== id));
  };

  // const updatePrice = (id: string, price: number) => {
  //   setItems(items.map((p) => (p.id === id ? { ...p, price } : p)));
  // };

  const availableItems = allItems.filter(
    (p) => !items.some((sp) => sp.id === p.id),
  );

  return (
    <Table className="roundedd-md shadoow-md">
      <TableHeader>
        <TableRow>
          <TableHead className="w-0">
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Plus className="h-4 w-4" />
                </Button>
              </DropdownMenuTrigger>

              <DropdownMenuContent align="start">
                <ScrollArea className="h-48">
                  {availableItems.map((item) => (
                    <DropdownMenuItem
                      key={item.id}
                      onSelect={() => {
                        addItem(item.id.toString());
                      }}
                    >
                      {item.name}
                    </DropdownMenuItem>
                  ))}
                </ScrollArea>
              </DropdownMenuContent>
            </DropdownMenu>
          </TableHead>

          <TableHead>{itemType}</TableHead>
          <TableHead>Price</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody>
        {items.map((item) => (
          <TableRow key={item.id}>
            <TableCell className="w-min">
              <Button
                variant="ghost"
                size="icon"
                onClick={() => {
                  removeItem(item.id);
                }}
              >
                <Trash2 className="h-4 w-4" />
                <span className="sr-only">Remove {item.name}</span>
              </Button>
            </TableCell>

            <TableCell>{item.name}</TableCell>
            <TableCell>{item.price}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
